export default __webpack_public_path__ + "static/10-3ab4b387c3f601ec97c7176a093ad73a.png";